import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { LocationService } from "../../shared/services/location.service";
import { Restaurant } from '../../shared/classes/restaurant';
import { RESULT } from '../../shared/services/env.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-domicilio',
  templateUrl: './domicilio.component.html',
  styleUrls: ['./domicilio.component.scss']
})
export class DomicilioComponent implements OnInit {

  themeLogo: string = 'assets/images/eatintime-logo.png'; // Default Logo
  public catFilter: any = [];
  search: string = '';
  public categories: any = [];
  public records: Restaurant[] = [];
  public recordsFiltered: Restaurant[] = [];

  onNotify(message: string): void {
    this.catFilter = [];
    this.catFilter.push(message);

    this.filterCat();
  }

  resetCat() {
    this.catFilter = [];
    //this.catFilter.push(55);
  }

  filterCat() {
    if (this.catFilter.length > 0) {
      this.recordsFiltered = this.records.filter(item => {
        //item.cucine.filter(kt => kt.id == this.category.id);
        for (var iC = 0; iC < item.cucine.length; iC++) {

          for (var iF = 0; iF < this.catFilter.length; iF++) {
            if (this.catFilter[iF] == item.cucine[iC].id || this.catFilter[iF] == 5) {
              return true;
            }
          }

        }
      });
    } else {
      this.recordsFiltered = this.records;
    }
  }

  constructor(private route: ActivatedRoute, private router: Router, private locService: LocationService,
    private viewScroller: ViewportScroller, private modalService: NgbModal) {
    // Get Query params..
    this.catFilter.push(55);


    this.locService.rest_delivery.subscribe(x => {
      if (x) {
        this.records = x;
        if (this.records) {
          this.updateCategory();
        }
        this.filterCat();
      }
    });
  }

  ngOnInit(): void {

    if (this.locService.isDeliveryOk(null) && !this.records) {
      this.locService.loadDelivery_R(true);
    }
  }

  updateCategory() {

    this.categories = [];

    var i = 0;
    for (i = 0; i < this.records.length; i++) {
      for (var iC = 0; iC < this.records[i].cucine.length; iC++) {
        var found = false;
        var id = this.records[i].cucine[iC].id;

        for (var j = 0; j < this.categories.length; j++) {
          if (id == this.categories[j].id) {
            this.categories[j].val++;
            found = true;
            break;
          }
        }
        if (found == false) {
          this.categories.push({
            name: this.records[i].cucine[iC].name,
            val: 1,
            id: this.records[i].cucine[iC].id,
            active: true
          });
        }
      }
    }
    this.categories.push({
      name: 'Tutte',
      val: 1,
      id: 55,
      active: true
    });

    this.resetCat();

  };


  openFilter() {
    console.log("open date");
    /* var order: any;
     order = this.cartData.order;
     let modal = this.modalService.open(DatetimeModalComponent, { size: 'md', centered: true, ariaLabelledBy: 'Datetime-Modal', windowClass: 'datetime-modal' })
     modal.componentInstance.order = order
     modal.componentInstance.init()
     modal.componentInstance.onDismiss.subscribe((event: any) => {
       if (event.status == RESPONSE.JPS_OK) {
         console.log("dismiss datetime response OK");
         this.cartData.order.order_date = event.orario;
         this.cartService.postOrario(this.cartData, event.orario, event.giornoconsegna);
       } else {
         console.log("dismiss datetime response ERROR");
       }
     })*/
  }

}
